'use client'

import { signIn, useSession } from 'next-auth/react'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import styles from './index.module.css'
import { Avatar, Text } from '@mantine/core'
import { useEasterEggs } from '@/app/lib/context/EasterEggContext'
import { useSeasonalAsset } from '@/app/lib/seasonalThemes'
import { SnowfallEffect } from '@/app/components/SnowyRunner/Snowfall/SnowfallEffect'
import { ValentineEffect } from '@/app/components/SnowyRunner/Valentine/ValentineEffect'
import { SEASONAL_ICON_ASSETS } from '@/app/lib/constants'
import snowyOnland from '../../../components/SpaceHunt/assets/snowy_onland.png'
import ballerIcon from '@/app/public/ballerIcon.png'

export default function Signin() {
  const { status } = useSession()
  const router = useRouter()
  const searchParams = useSearchParams()
  const callbackUrl = searchParams.get('callbackUrl')

  useEffect(() => {
    if (status === 'unauthenticated') {
      signIn('bsso')
    } else if (status === 'authenticated') {
      router.push(callbackUrl || '/')
    } else {
      router.push('/')
    }
  }, [status, router, callbackUrl])

  const seasonalFlags = useEasterEggs()
  const { asset: currentIcon, theme } = useSeasonalAsset(seasonalFlags, SEASONAL_ICON_ASSETS)
  const iconSrc = seasonalFlags.isBasketball ? ballerIcon.src : seasonalFlags.isAprilFools ? snowyOnland.src : currentIcon.src

  return (
    <div className={styles.signInPage}>
      <SnowfallEffect isActive={theme === 'christmas'} />
      <ValentineEffect isActive={theme === 'valentine'} />
      <div className={styles.spinnerWrap} role="status" aria-busy="true" aria-live="polite">
        <Avatar src={iconSrc} size={180} alt="" />
      </div>
      <Text size="xl" fs="italic">
        Signing in...
      </Text>
    </div>
  )
}
